__turbopack_context__.v({
  "text": "a-text-module-scss-module__sQ3oYG__text",
});
